import _ from 'lodash';
import { HITLBase } from './HITLBase';
export class SessionRelations extends HITLBase {
    static getSessionRelations(options) {
        const route = this.getBaseUrl(options);
        const params = _.omit(options, ['version']);
        return this.request({
            method: 'GET',
            route,
            params,
        });
    }
    static createSessionRelations(options) {
        const route = this.getBaseUrl(options);
        const data = _.omit(options, ['version']);
        return this.request({
            method: 'POST',
            route,
            data,
        });
    }
    static deleteSessionRelations(options) {
        const route = this.getBaseUrl(options);
        const data = _.omit(options, ['version']);
        return this.request({
            method: 'DELETE',
            route,
            data,
        });
    }
}
SessionRelations.MODULE_URL = 'session-relations';
//# sourceMappingURL=SessionRelations.js.map